export const codeMap = {
  4: '04',
  28: '19',
  51: '04',
  29: '04',
  101: '01',
};
